import type { SVGProps } from 'react';

export default (props: SVGProps<SVGSVGElement>) => <svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M5 11V13H19V11H5Z"/></svg>